module.exports = __webpack_public_path__ + "static/media/1010174.7fd2951e.png";